import * as THREE from 'three'

import config from '../../config'

import renderer from '../../renderer'

import emitter from '../../emitter'

import EVENTS from '../../globals/eventslist'

// SAMSY LICENCE

// HTTP://SAMSY.NINJA

import {

    DEBUG,
    FBO_DEBUG

} from 'constants'

import Quad from './quad'


import FBOHELPER from '../../globals/fbohelper'


class PostProcessing {

    constructor(scen, cam, rend) {

        this.camera = cam

        this.settings = {}

        this.oldClearColor = new THREE.Color();

        this.oldClearAlpha = 1;

        this.useRGBA = true

        this.colorBlack = new THREE.Color(0, 0, 0);

        this.target = new THREE.WebGLRenderTarget(1, 1, {
          minFilter: this.settings.minFilter !== undefined ? this.settings.minFilter : THREE.LinearFilter,
          magFilter: this.settings.magFilter !== undefined ? this.settings.magFilter : THREE.LinearFilter,
          wrapS: this.settings.wrapS !== undefined ? this.settings.wrapS : THREE.ClampToEdgeWrapping,
          wrapT: this.settings.wrapT !== undefined ? this.settings.wrapT : THREE.ClampToEdgeWrapping,
          format: this.useRGBA ? THREE.RGBAFormat : THREE.RGBAFormat,
          type: this.settings.type !== undefined ? this.settings.type : THREE.UnsignedByteType,
          stencilBuffer: this.settings.stencilBuffer !== undefined ? this.settings.stencilBuffer : true,
          depthBuffer: this.settings.depthBuffer !== undefined ? this.settings.depthBuffer : true
        }); 

        this.occlusionTarget = new THREE.WebGLRenderTarget(1, 1, {
          minFilter: this.settings.minFilter !== undefined ? this.settings.minFilter : THREE.LinearFilter,
          magFilter: this.settings.magFilter !== undefined ? this.settings.magFilter : THREE.LinearFilter,
          wrapS: this.settings.wrapS !== undefined ? this.settings.wrapS : THREE.ClampToEdgeWrapping,
          wrapT: this.settings.wrapT !== undefined ? this.settings.wrapT : THREE.ClampToEdgeWrapping,
          format: this.useRGBA ? THREE.RGBAFormat : THREE.RGBAFormat,
          type: this.settings.type !== undefined ? this.settings.type : THREE.UnsignedByteType,
          stencilBuffer: this.settings.stencilBuffer !== undefined ? this.settings.stencilBuffer : true,
          depthBuffer: this.settings.depthBuffer !== undefined ? this.settings.depthBuffer : true
        });  


        if(FBO_DEBUG){
                    
            FBOHELPER.attach(this.target, 'colortarget')

        }

        this.resize(window.innerWidth, window.innerHeight)

        this.quad = new Quad()

        this.passes = []

        this.addEvents()

    }


    render(scene, camera) {

        emitter.emit(EVENTS.occlusion, false)

        renderer.setRenderTarget(this.target)

        renderer.render(scene, camera)

        emitter.emit(EVENTS.occlusion, true)

        renderer.setRenderTarget(this.occlusionTarget)

        renderer.render(scene, camera)

        emitter.emit(EVENTS.occlusion, false)

        this.quad.render(this.target, this.occlusionTarget);

    }


    resize(w, h) {

        this.target.setSize(Math.floor(w  * config.devicePixelRatio), Math.floor(h  * config.devicePixelRatio));
        this.occlusionTarget.setSize(Math.floor(w  * config.devicePixelRatio), Math.floor(h  * config.devicePixelRatio));

    }

    nearestPowerOfTwo ( value ) {

        return Math.pow( 2, Math.round( Math.log( value ) / Math.LN2 ) );

    }

    addEvents() {

        emitter.on('resize', this.resize.bind(this))
    }

}

export default PostProcessing;


// WEBPACK FOOTER //
// ./src/scripts/Trail/modules/postprocessing/index.js